'use client';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The few words the primitives themselves say, such as the "required" a
 * screen reader hears in a group's label. @leanin/ui ships no translations:
 * the app provides its own wording once, above everything it renders, and a
 * primitive outside any provider speaks English.
 */
import { createContext, useContext } from 'react';
const ENGLISH = {
    required: 'required',
    comboboxSearchPlaceholder: 'Search…',
    comboboxNoMatches: 'No matches',
    comboboxSearching: 'Searching…',
    comboboxRemoveLabel: (label) => `Remove ${label}`,
    cardRailScrollBackward: 'Scroll backward',
    cardRailScrollForward: 'Scroll forward',
    tabBarMore: 'More',
    tabBarMoreActions: 'More actions',
    searchInputPlaceholder: 'Search',
    searchInputClear: 'Clear search',
};
const UiStringsContext = createContext(ENGLISH);
export function UiStringsProvider({ value, children }) {
    return _jsx(UiStringsContext.Provider, { value: value, children: children });
}
export function useUiStrings() {
    return useContext(UiStringsContext);
}
//# sourceMappingURL=UiStrings.js.map